import type { SegmentEventQueueEvent } from '@/typings/segment-manager';

interface SegmentUrlCommands {
  readonly anonymousId?: string;
  readonly events: SegmentEventQueueEvent[];
}

/** Preserve Segment URL commands once, through booking's consent-aware queue. */
export function getSegmentUrlCommands(): SegmentUrlCommands {
  const { search } = window.location;
  const query = search === '' ? window.location.hash.replace(/^.*\?/u, '?') : search;
  const parameters = new URLSearchParams(query);
  const userId = parameters.get('ajs_uid');
  const eventName = parameters.get('ajs_event');
  const rawAnonymousId = parameters.get('ajs_aid');
  const anonymousId = rawAnonymousId !== null && rawAnonymousId !== '' ? rawAnonymousId : undefined;
  const traits: Record<string, string> = {};
  const properties: Record<string, string> = {};

  for (const [key, value] of parameters) {
    if (key.startsWith('ajs_trait_')) {
      traits[key.slice('ajs_trait_'.length)] = value;
    }

    if (key.startsWith('ajs_prop_')) {
      properties[key.slice('ajs_prop_'.length)] = value;
    }
  }

  const events: SegmentEventQueueEvent[] = [];

  if (userId !== null && userId !== '') {
    events.push({
      type: 'identify',
      userId,
      traits
    });
  }

  if (eventName !== null && eventName !== '') {
    events.push({
      type: 'track',
      eventName,
      payload: properties
    });
  }

  return {
    anonymousId,
    events
  };
}
